// Qué hace el TPV al montar el layout con los flags de dispositivo que dejó
// `useDeviceEnforcementHub` en localStorage (función pura).
//
//   { action: "wait" }               hay empleado asignado pero el catálogo
//                                    de empleados aún no ha llegado
//   { action: "assign", employee }   identificar al empleado asignado
//   { action: "kiosk" }              el dispositivo exige elegir empleado y
//                                    no hay ninguno → kiosko bloqueante
//   { action: "none" }               nada que hacer
//
// Es una decisión de ARRANQUE: salvo "wait", se toma una sola vez. Antes el
// efecto se volvía a evaluar en cada cambio de `currentActiveEmployee`; con
// «exigir selección» activo, pasarse del empleado al admin (con su PIN)
// dejaba `currentActiveEmployee = 0` y el kiosko se reabría → se pedía el
// PIN otra vez.
export function decideDeviceEnforcementOnMount({
  assignedId,
  requireSelection,
  employees,
  currentActiveEmployee,
}) {
  const id = Number(assignedId) || 0;
  if (id > 0) {
    const employee = (employees || []).find((e) => e?.id === id);
    if (!employee) return { action: "wait" };
    return { action: "assign", employee };
  }
  if (requireSelection && !currentActiveEmployee) return { action: "kiosk" };
  return { action: "none" };
}

// La decisión es por CARGA DE PÁGINA y sesión web, no por montaje del
// layout: al entrar en una mesa (TpvCartaLayout) y volver, el
// DashboardLayout se vuelve a montar y un `useRef` empezaba de cero → con el
// admin elegido (0) el kiosko se reabría. Una recarga (la que hace
// `useDeviceEnforcementHub` al cambiar los flags) o un login nuevo (otro
// `sessionIdentifier`) vuelven a decidir.
let decidedFor = null;

export function hasDecidedDeviceEnforcement(sessionKey) {
  return decidedFor !== null && decidedFor === (sessionKey || "");
}

export function markDeviceEnforcementDecided(sessionKey) {
  decidedFor = sessionKey || "";
}

export function resetDeviceEnforcementDecision() {
  decidedFor = null;
}
